import { render, staticRenderFns } from "./BrainsMap.vue?vue&type=template&id=c671bdfa&scoped=true&"
import script from "./BrainsMap.vue?vue&type=script&lang=js&"
export * from "./BrainsMap.vue?vue&type=script&lang=js&"
import style0 from "./BrainsMap.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrainsMap.vue?vue&type=style&index=1&id=c671bdfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c671bdfa",
  null
  
)

export default component.exports